module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/plus-b1871be54b5bba763ef02a5a19bde0e8.svg";